module.exports = __webpack_public_path__ + "img/51.b6ff36e1.png";